import axios from "axios";
import getPageName from "../getPageName";
import {modals} from "../modal/init-modals";

const send = () => {
  const formCitizenRequest =
    "https://hermes.smile-tech.study/api/v1/lead?programId=";
  const AmoWebinar =
    "https://n8n.edusigmatecharskay.ru/webhook/webinar/amo/sigmasz/5/u9x7m1Uz5PskxaPy";
  const TelegramCRM = "https://n8n.edusigmatecharskay.ru/webhook/n8n/landing_pb/WD4aAeCuhUTi7q7V/0b2f3e";

  const invalidCharsRegex = /[^a-zA-Z0-9.@_-]/; // Разрешённые символы

  $("[type=email]").on("input", function () {
    const inputValue = $(this).val();

    // Проверяем наличие недопустимых символов
    const invalidChars = inputValue.match(invalidCharsRegex);
    const input = $(this).get(0);
    const inputParent = $(this).parent().get(0);

    if (input.classList.contains("form__field--invalid")) {
      input.classList.remove("form__field--invalid");
      inputParent.querySelector(".form__error-container")?.remove();
    }
    const error = {};

    if (invalidChars) {
      error.message = `Недопустимый символ: "${invalidChars[0]}"`;
      input.classList.add("form__field--invalid");

      showError(error, inputParent);
    }
  });

  // Подсказки для ввода почты
  const validDomains = [
    "yandex.ru",
    "mail.ru",
    "gmail.com",
    "hotmail.com",
    "outlook.com",
  ];

  $("[type=email]").on("input", function () {
    const emailInput = $(this);
    const emailValue = emailInput.val();
    const suggestionsDiv = emailInput.siblings(".suggestions");

    const atIndex = emailValue.indexOf("@");
    if (atIndex !== -1) {
      const domainPart = emailValue.slice(atIndex + 1);
      const suggestions = validDomains.filter((domain) =>
        domain.startsWith(domainPart)
      );
      suggestionsDiv.empty(); // Очистка предыдущих подсказок

      if (suggestions.length > 0) {
        suggestions.forEach((domain) => {
          suggestionsDiv.append(
            `<span class="suggestion-item">${emailValue.slice(
              0,
              atIndex + 1
            )}${domain}</span>`
          );
        });
        suggestionsDiv.show();
      } else {
        suggestionsDiv.hide();
      }
    } else {
      suggestionsDiv.hide();
    }
  });

  // Обработчик клика на предложениях
  $(document).on("click", ".suggestion-item", function () {
    const emailInput = $(this).closest("form").find("[type=email]");
    emailInput.val($(this).text()).focus();
    emailInput.siblings(".suggestions").hide();
  });

  /**
   * Валидаторы
   */
  var validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = "Это поле обязательно";
        return false;
      } else {
        return true;
      }
    },
    phone: function (value, error) {
      if (
        /^((\+7|7|8)\s?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2}))$/.test(
          value
        )
      ) {
        return true;
      } else {
        error.message = "Некорректный номер телефона";
        return false;
      }
    },
    email: function (value, error) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный email";
        return false;
      }
    },
    birthday: function (value, error) {
      var parts = value.split(".");
      if (
        parts.length != 3 ||
        parts[0].length != 2 ||
        parts[1].length != 2 ||
        parts[2].length != 4
      ) {
        error.message = "Некорректная дата рождения";
        return false;
      }

      return true;
    },
  };

  /**
   * Показ ошибок в вёрстке
   * @param {Object} error Объект ошибки
   * @param {HTMLElement} field Элемент поля ввода
   */
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement("div");
      errorContainer.textContent = error.message;
      errorContainer.classList.add("form__error-container");
      field.appendChild(errorContainer);
    }
  }

  /**
   * Удаление ошибок из формы
   * @param {HTMLElement} form Форма
   */
  function deleteErrors(form) {
    form.querySelectorAll(".form__error-container").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll(".form__field--invalid").forEach(function (el) {
      el.classList.remove("form__field--invalid");
    });
  }

  /**
   * Валидация формы
   * @param {HTMLElement} form Форма
   * @returns Валидна ли форма
   */
  function validate(form) {
    var result = true;
    Array.from(form.querySelectorAll(".form__field")).forEach(function (
      formField
    ) {
      var error = {};
      var control = formField.querySelector("select, input, textarea");
      if (formField.querySelector(".form__required")) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
          return;
        }
      }

      if (control.type === "tel") {
        if (!validators.phone(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }

      if (control.type === "email") {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }

      if (control.id === "birthday") {
        if (!validators.birthday(control.value, error)) {
          showError(error, formField);
          control.classList.add("form__field--invalid");
          result = false;
        }
      }
    });

    let invalidField = form.querySelector(".form__field--invalid");
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    return result;
  }

  /**
   * Установка масок ввода
   */
  function setMasks() {
    $("#phone").mask("+7 (999) 999-99-99", { autoclear: false });
    $("#phone-aiWebinar").mask("+7 (999) 999-99-99", { autoclear: false });
    $("input[type='tel']").mask("+7 (999) 999-99-99", { autoclear: false });
  }

  /**
   * Получение cookie
   */
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /**
   * Отправка данных из формы и url
   * @param {Event} e Событие submit
   */
  function send(form, e, modalData, quiz = false) {
    var sendBtn = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      ),
      data = {};

    if (modalData) {
      data = { ...modalData };
    } else {
      e.preventDefault();
      deleteErrors(form);
      data = {};
      
      if (!validate(form)) {
        return;
      }

      // Валидация капчи
      if (form.querySelector('[name="smart-token"]') && !form.querySelector('[name="smart-token"]').value) {
        form.querySelector('.smart-captcha--error').style.display = "block";
        return
        
      } else if (form.querySelector('.smart-captcha--error')) {        
        form.querySelector('.smart-captcha--error').style.display = "none";
      }      

      Array.from(new FormData(form)).forEach(function (formElement) {
        var key = formElement[0];
        var value = formElement[1];
        if (key == "BirthDate") {
          data[key] = value.split(".").reverse().join("-");
        } else if (key == "Region") {
          // Регион отправляется и из основной формы (#Regions), и из hero-формы
          // (#Regions-program) — название ищем в селекте именно той формы,
          // которая сабмитится, а не всегда в #Regions
          data[key] = returnRegionName(form.querySelector('select[name="Region"]'), value);
          data["RegionId"] = value;
        } else if (key == "cohort_id") {
          data[key] = value ? Number(value) : null;
        } else {
          data[key] = value;
        }
      });
    }
    sendBtn.disabled = true;

    let url = document.location.href,
      paramsStartIndex = url.indexOf("?");

    // UTM
    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split("&")
        .map(function (utmString) {
          return utmString.split("=");
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf("#") > -1
              ? value.slice(0, value.indexOf("#"))
              : value;
          data[key] = value;
        });
    } else {
      if (getCookie("utm_tags")) {
        getCookie("utm_tags")
          .slice(paramsStartIndex + 1, getCookie("utm_tags").length)
          .split("&")
          .map(function (utmString) {
            return utmString.split("=");
          })
          .forEach(function (utmMark) {
            var key = utmMark[0];
            key = key[0].toUpperCase() + key.slice(1, key.length);
            var value = utmMark[1];
            value =
              value.indexOf("#") > -1
                ? value.slice(0, value.indexOf("#"))
                : value;
            data[key] = value;
          });
      }
    }

    data["Landing"] = url.split("?")[0] || url;

    toastr.options.progressBar = true;

    let ym_uid = getCookie("_ym_uid");
    if (ym_uid) {
      data["ClientId"] = ym_uid;
    }

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");

    if (!!roistatCookie) {
      data["RoistatCookie"] = roistatCookie;
    }

    if (!data.Program) {
      const title = document.querySelector(".home__title")?.textContent;

      if (title) {
        let newProgram = title.slice(
          title.indexOf("«") + 1,
          title.indexOf("»")
        );
        data["Program"] = newProgram;
      }
    }

    /* Добавление данных в передачу формы */
    const programList = document.querySelector("#ProgramHome")?.children,
      programHidden = form.querySelector(".program-hidden");

    if (programList && !programHidden) {
      [...programList].forEach((item) => {
        if (data["Program"] == item.value) {
          if (item.getAttribute("operator")) {
            data["Operator"] = item.getAttribute("operator");
          }

          if (item.getAttribute("shortname")) {
            data["shortname"] = item.getAttribute("shortname");
          }

          if (item.getAttribute("program_group_id")) {
            data["program_group_id"] = Number(
              item.getAttribute("program_group_id")
            );
          }

          if (item.getAttribute("program_id")) {
            if (
              item.getAttribute("program_id") == "null" ||
              item.getAttribute("program_id") == null
            ) {
              data["program_id"] = null;
            } else {
              data["program_id"] = Number(item.getAttribute("program_id"));
            }
          }

          if (item.getAttribute("linkrvr")) {
            data["rvr_link"] = item.getAttribute("linkrvr");
          }
        }
      });
    } else {
      if (programHidden) {
        if (programHidden.getAttribute("operator")) {
          data["Operator"] = programHidden.getAttribute("operator");
        }

        if (programHidden.getAttribute("shortname")) {
          data["shortname"] = programHidden.getAttribute("shortname");
        }

        if (programHidden.getAttribute("program_group_id")) {
          data["program_group_id"] = Number(
            programHidden.getAttribute("program_group_id")
          );
        }

        if (programHidden.getAttribute("program_id")) {
          if (
            programHidden.getAttribute("program_id") == "null" ||
            programHidden.getAttribute("program_id") == null
          ) {
            data["program_id"] = null;
          } else {
            data["program_id"] = Number(
              programHidden.getAttribute("program_id")
            );
          }
        }

        if (programHidden.getAttribute("linkrvr")) {
          data["rvr_link"] = programHidden.getAttribute("linkrvr");
        }
      }
    }

    let DATA_BASE =
      form.id == "form-webinar"
        ? AmoWebinar
        : formCitizenRequest + data["program_id"];
        
    axios
      .post(DATA_BASE, data)
      .then(function () {
        sendBtn.disabled = false;

        /* Метрики */
        ym(100783979, "reachGoal", "submit");
        var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ type: "reachGoal", id: 3663076, goal: "lead" });

        VK.Goal("lead");
        VK.Retargeting.Event("lead");

        _tmr.push({ type: "reachGoal", id: 3678508, goal: "lead" });

        if (form.id == "hero-form") {
          ym(100783979, "reachGoal", "submit_short");
        }

        if (form.id == "form-webinar") {
          openWebinarModal();
          ym(100783979, "reachGoal", "submit_webinar");
        } else {
          if (getPageName() == "ai-start" || getPageName() == "ai-start-fb" || getPageName() == "ai-start-tg") {
            // Меняем ссылки в модальном окне
            const modal = document.querySelector('.success-modal');

            if (modal) {
              const links = modal.querySelectorAll('a');

              links?.forEach(link => {
                if (getPageName() == "ai-start-fb") {
                  link.href = "https://sbsite.pro//02740081d81b4f87fdb002dfd3c198ee_1";
                } else if (getPageName() == "ai-start-tg") {
                  link.href = "https://t.me/ProfifutureII_Bot?start=tg_ads_ii";
                }
              })              
            }

            modals.open("success-free-program");
          } else {
            /* Отправка данных в новую базу */
            sendFormCRM(data);
          }
        }

        form.reset();
        $("#Regions").val("").trigger("change");
        $("#ProgramHome").val("").trigger("change");
        $("#education-level").val("").trigger("change");
        $("#education-level-short").val("").trigger("change");
        $("#date").val("").trigger("change");
        $("#citizenship").val("").trigger("change");
        $("#gender").val("").trigger("change");
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;

        if (error.response.status == 429) {
          toastr.error(
          "Капча не пройдена! Перезагрузите страницу и попробуйте снова",
          { duration: 15000, fadeDuration: 500 }
        );
        } else {
          toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          { duration: 3000, fadeDuration: 500 }
        );
        }
      });
  }

  function sendFormCRM(data) {
    axios
      .post(TelegramCRM, data)
      .then((response) => {
        openNoRedirectSaveBaseModal(
          `https://t.me/ProfifutureBot?start=landing_${response.data.hash}`
        );
      })
      .catch((error) => {
        openNoRedirectSaveBaseModal(`https://t.me/ProfifutureBot`);
      });
  }

  /**
   * Начало заполнения формы
   */
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll("input, select, textarea");
    let changed = false;
    controls.forEach((control) => {
      $(control).one("blur", (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /**
   * Установка формы
   */
  function setForm(selector, small = false) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    form.addEventListener("submit", function (e) {
      if (selector == "#form-aiWebinar") {
        sendWebinar(form, e);       
      } else {
        send(form, e, small);
      }
    });

    addMaxLength(form);
    onFormFilling(form, () => {
      if (selector == "#form-webinar") {
        ym(100783979, "reachGoal", "submit_start_webinar");
      }

      ym(100783979, "reachGoal", "submit_start");
      VK.Retargeting.Event("Initiate_Checkout");
      _tmr.push({ type: "reachGoal", id: 3678508, goal: "initiate_checkout" });
    });
  }

  /**
   * Установка максимального количества символов в полях формы
   */
  function addMaxLength(form) {
    form
      .querySelectorAll('input[type="text"], textarea')
      .forEach((control) => control.setAttribute("maxlength", "250"));
  }

  /**
   * Блокировка кнопки отправки формы
   */
  function setFormCheckbox(arr, btn) {
    try {
      arr.forEach((item) => {
        item.addEventListener("change", function () {
          // Отключенные чекбоксы (например, скрытый #check-moscow) не должны
          // блокировать отправку — учитываем только включенные
          if (!arr.find((checkbox) => !checkbox.disabled && !checkbox.checked)) {
            btn.removeAttribute("disabled");
          } else {
            btn.setAttribute("disabled", "disabled");
          }
        });
      });
    } catch (e) {}
  }

  const MOSCOW_REGION_VALUES = ["49", "79", "91"];
  const MOSCOW_ONLY_PROGRAMS = [
    "data-analytics",
    "software-testing",
    "marketplace",
    "promptengineer",
    "graphicdesign",
    "accountant",
    "project-manager",
    "excel-data",
    "psychologist",
    "internet-marketer",
    "logistics",
    "hr",
    "procurement",
    "pedagogy",
    "information-security",
    "methodist",
    "social-media"
  ];

  function updateMoscowCheckbox() {
    const regionSelect = document.getElementById("Regions");
    const programSelect = document.getElementById("ProgramHome");
    const wrapper = document.getElementById("check-moscow-wrapper");
    const checkbox = document.getElementById("check-moscow");
    const ofertaLink = document.querySelector('label[for="oferta"] a');

    if (!wrapper || !checkbox || !regionSelect) return;

    const regionValue = regionSelect.value;

    /* Главная: программа выбирается в селекте #ProgramHome.
       Страница программы: селекта нет, программа зафиксирована самой
       страницей — её shortname берём из URL. */
    const programShortname = programSelect
      ? programSelect.options[programSelect.selectedIndex]?.getAttribute("shortname")
      : getPageName();

    const shouldShow =
      MOSCOW_REGION_VALUES.includes(regionValue) &&
      MOSCOW_ONLY_PROGRAMS.includes(programShortname);

    if (shouldShow) {
      wrapper.style.display = "";
      checkbox.disabled = false;
      if (ofertaLink) ofertaLink.setAttribute("href", "/files/oferta_edu.pdf");
    } else {
      wrapper.style.display = "none";
      checkbox.disabled = true;
      checkbox.checked = false;
      if (ofertaLink) ofertaLink.setAttribute("href", "/files/oferta.pdf");
    }

    checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* Возвращает название региона для отправки формы */
  function returnRegionName(regionSelect, region) {
    if (!regionSelect) return "";

    let regionList = regionSelect.querySelectorAll("option");

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].textContent;
      }
    }
  }

  /**
   * Функция добавления стилей
   */
  function setStyles(el, stylesObject) {
    if (!el) {
      return;
    }
    Object.keys(stylesObject).forEach((key) => {
      el.style[key] = stylesObject[key];
    });
  }

  /**
   * Функция с модальными окнами при успешной отправки фломы
   */
  function successModal() {
    let modal = document.querySelector("#quiz-success");

    if (!modal) {
      modal = document.createElement("div");
      ["modal", "quiz"].forEach((additionalClass) => {
        modal.classList.add(additionalClass);
      });
      modal.id = "quiz-success";
      modal.innerHTML = '<div class="quiz__content"></div>';

      document.body.append(modal);
    }

    const a = document.createElement("a");
    a.href = "#quiz-success";
    a.rel = "modal:open";
    a.style.display = "none";
    document.body.append(a);

    window.openNoRedirectSaveBaseModal = (link) => {
      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        visibility: "visible",
        transform: "scale(1)",
        opacity: "1",
        paddingBottom: "2rem",
      });

      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <h3 class="title--decor rvr-modal__title">Благодарим за заявку!</h3>
          <p class="norvr-modal__p">Ваша заявка попала в&nbsp;список приоритетных кандидатов.</p>
          <p class="norvr-modal__p">Координатор свяжется с&nbsp;Вами <span style="color: #3052d8; font-family: Proxima Nova - Bold, sans-serif;
            font-weight: 700;">в&nbsp;ближайшие 3&nbsp;дня</span> с&nbsp;номера <span style="color: #3052d8; font-family: Proxima Nova - Bold, sans-serif;
            font-weight: 700;">+7&nbsp;(966)&nbsp;999-87-40</span> для консультации.</p>
          <p class="norvr-modal__p">Дополнительная информация будет направлена на&nbsp;почту.</p>
        `;

      a.click();

      const button = document.querySelector(".rvr-modal .close-modal");
      const overflow = document.querySelector('.jquery-modal');
      button.addEventListener("click", () => {
        window.location.assign(link);
      });
      overflow.addEventListener("click", () => {
        window.location.assign(link);
      });
    };

    window.openWebinarModal = () => {
      modal.classList.add("norvr-modal", "rvr-modal");
      setStyles(modal, {
        position: "relative",
        visibility: "visible",
        transform: "scale(1)",
        opacity: "1",
        paddingBottom: "2rem",
      });

      modal.querySelector(".quiz__content").innerHTML = /*html*/ `
          <h3 class="title--decor rvr-modal__title" style="text-align: center">Заявка принята!</h3>
          <p class="norvr-modal__p">Подключите Telegram-бот — он напомнит о&nbsp;вебинаре, чтобы вы ничего не упустили и&nbsp;смогли прокачаться в&nbsp;профессии. Отключиться можно в&nbsp;любой момент.</p>
          <div class="rvr-modal__bottom" style="justify-content: center">
            <a href="https://sbsite.pro//f198fb55e96b653e77ac9b320baa475d_1" class="rvr-modal__link bot_button  TelegramClickSZ TelegramBotClick" rel="nofollow noopener noreferrer" target="_blank" data-bot-link>Подключить</a>
          </div>
        `;

      a.click();
    };
  }

  function sendWebinar(form, e) {
    var sendBtn = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      ),
      data = {};

    e.preventDefault();
    deleteErrors(form);
    data = {};
    if (!validate(form)) {
      return;
    }

    Array.from(new FormData(form)).forEach(function (formElement) {
      let key = formElement[0];
      let value = formElement[1];

      data[key] = value;
    });

    sendBtn.disabled = true;

    let url = document.location.href,
      paramsStartIndex = url.indexOf("?");

    // UTM
    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split("&")
        .map(function (utmString) {
          return utmString.split("=");
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf("#") > -1
              ? value.slice(0, value.indexOf("#"))
              : value;
          data[key] = value;
        });
    } else {
      if (getCookie("utm_tags")) {
        getCookie("utm_tags")
          .slice(paramsStartIndex + 1, getCookie("utm_tags").length)
          .split("&")
          .map(function (utmString) {
            return utmString.split("=");
          })
          .forEach(function (utmMark) {
            var key = utmMark[0];
            key = key[0].toUpperCase() + key.slice(1, key.length);
            var value = utmMark[1];
            value =
              value.indexOf("#") > -1
                ? value.slice(0, value.indexOf("#"))
                : value;
            data[key] = value;
          });
      }
    }

    data["Landing"] = url.split("?")[0] || url;

    toastr.options.progressBar = true;

    let ym_uid = getCookie("_ym_uid");
    if (ym_uid) {
      data["ClientId"] = ym_uid;
    }

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");

    if (!!roistatCookie) {
      data["RoistatCookie"] = roistatCookie;
    }

    axios
      .post(
        "https://n8n.edusigmatecharskay.ru/webhook/webinar/amo/sigmasz/8/NsqKW5K8wkkWfHSY",
        data
      )
      .then(function () {
        sendBtn.disabled = false;        
        modals.open('aiWebinar-modal');
        form.reset();
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;
        toastr.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          { duration: 3000, fadeDuration: 500 }
        );
      });
  }

  // Инициализация
  $(function () {
    setTimeout(() => {
      VK.Retargeting.Event("PageView30sec");
    }, 30000);

    setMasks();
    setForm("#form-app");
    setForm("#form-webinar");
    setForm("#hero-form");
    setForm("#form-aiWebinar");
    successModal();
    setFormCheckbox(
      [
        document.querySelector("#personal-data"),
        document.querySelector("#personal-data--pd"),
        document.querySelector("#oferta"),
        document.querySelector("#check-moscow"),
      ],
      document.querySelector(".form__btn")
    );
    setFormCheckbox(
      [
        document.querySelector("#personal-data-modal"),
        document.querySelector("#personal-data-modal--pd"),
      ],
      document.querySelector(".submit-modal")
    );
    setFormCheckbox(
      [document.querySelector("#personal-data-1")],
      document.querySelector("#btn-home-1")
    );
    setFormCheckbox(
      [document.querySelector("#personal-data-2")],
      document.querySelector("#btn-home-2")
    );
    setFormCheckbox(
      [document.querySelector("#webinar-checkbox")],
      document.querySelector("#webinar-sumbit")
    );

    updateMoscowCheckbox();
    $(document).on("change", "#Regions, #ProgramHome", updateMoscowCheckbox);
  });
};

export default send;
